import { useQuery } from '@fv/client-core'
import type {
  CfrHazardousMaterial,
  CfrHazmatIdNumberSearchQuery,
  CfrHazmatSearchQuery,
} from '@fv/models'

import { shipperFetch } from '../../../utils/shipperFetch'
import type { CfrHazmatField } from './cfrHazmat'

const cfrHazmatQueryKeys = {
  all: ['cfr-hazmat'],
  search: (field: CfrHazmatField, term: string) => [
    ...cfrHazmatQueryKeys.all,
    field,
    term,
  ],
}

export const useCfrHazmatSearch = (field: CfrHazmatField, term: string) => {
  return useQuery(
    cfrHazmatQueryKeys.search(field, term),
    () =>
      field === 'identificationNumber'
        ? shipperFetch<CfrHazardousMaterial[]>('/cfr-hazmat/search/id-number', {
            query: {
              identificationNumber: term,
            } satisfies CfrHazmatIdNumberSearchQuery,
          })
        : shipperFetch<CfrHazardousMaterial[]>('/cfr-hazmat/search', {
            query: { properShippingName: term } satisfies CfrHazmatSearchQuery,
          }),
    {
      enabled: term?.trim().length > 1,
      staleTime: Infinity,
    },
  )
}
